import Utils from '../../utils/util';

const tpl: FreeObjMap = {
    "id": null,
    "type": null,
    "moduleName": null,
    "tplName": null,
    "cubeName": null,
    "desc": null,
    "frontCubeData": null,
    "cubeData": {
        "pageSize": 10,
        "dataMap": {},
        "id": null,
        "status": null,
        "created": null,
        "modified": null,
        "yn": null,
        "creator": null,
        "updator": null,
        "layerId": null,
        "specialAttr": null,
        "serialNumber": null,
        "unitType": 1,
        "surfaceWidth": 1,
        "surfaceHeight": 1,
        "surfaceDepth": 1,
        "maxNum": null,
        "minNum": null,
        "actualNum": null,
        "skuId": -9999,
        "displayPosType": null,
        "posCapacity": null,
        "posWidth": null,
        "posHeight": null,
        "posDepth": null,
        "posX": null,
        "posY": null,
        "posZ": null,
        "axisX": null,
        "axisY": null,
        "axisZ": null,
        "posDirection": "1",
        "boxSpec": null,
        "hangnailId": null,
        "imgRotateType": 1,
        "xplaceType": 0,
        "xsurfaceType": 0,
        "xsurfaceWidthType": 0,
        "xminSurfaceType": 0,
        "xminSurfaceNum": null,
        "xmaxSurfaceType": 0,
        "xmaxSurfaceNum": null,
        "xtargetSurfaceType": 0,
        "xtargetSurfaceNum": null,
        "xtargetPileType": 0,
        "xtargetPileNum": null,
        "xpileType": 0,
        "xpilePos": "1",
        "xsurfaceNum": null,
        "xpileDirection": 0,
        "xtargetSpace": 0,
        "yplaceType": 0,
        "ysurfaceType": 0,
        "ysurfaceWidthType": 0,
        "yminSurfaceType": 0,
        "yminSurfaceNum": null,
        "ymaxSurfaceType": 0,
        "ymaxSurfaceNum": null,
        "ytargetSurfaceType": 0,
        "ytargetSurfaceNum": null,
        "ytargetPileType": 0,
        "ytargetPileNum": null,
        "ypileType": 0,
        "ypilePos": "1",
        "ysurfaceNum": null,
        "ypileDirection": 0,
        "ytargetSpace": 0,
        "zplaceType": 0,
        "zsurfaceType": 0,
        "zsurfaceWidthType": 0,
        "zminSurfaceType": 0,
        "zminSurfaceNum": null,
        "zmaxSurfaceType": 0,
        "zmaxSurfaceNum": null,
        "ztargetSurfaceType": 0,
        "ztargetSurfaceNum": null,
        "ztargetPileType": 0,
        "ztargetPileNum": null,
        "zpileType": 0,
        "zpilePos": "1",
        "zsurfaceNum": null,
        "zpileDirection": 0,
        "ztargetSpace": 0,
        "warning": null,
        "frontData": null,
        "shelfWareStatus": null,
        "usePartition": 0,
        "virtualLayerNumber": null,
        "virtualSerialNumber": null,
        "audFlag": null,
        "audMsg": null,
        "xPileSurfaceWidth": null,
        "xPileSurfaceHeight": null,
        "xPileSurfaceDepth": null,
        "yPileSurfaceWidth": null,
        "yPileSurfaceHeight": null,
        "yPileSurfaceDepth": null,
        "zPileSurfaceWidth": null,
        "zPileSurfaceHeight": null,
        "zPileSurfaceDepth": null,
        "boxSpecList": [{
            "skuId": -9999,
            "packageName": "H02",
            "packageUnit": "H02",
            "radio": 2,
            "begrew": null,
            "depth": 10,
            "width": 10,
            "height": 10,
            "cubage": 1000,
            "color": null,
            "venderId": 1,
            "rfId": "230698"
        }, {
            "skuId": -9999,
            "packageName": "H06",
            "packageUnit": "H06",
            "radio": 6,
            "begrew": null,
            "depth": null,
            "width": null,
            "height": null,
            "cubage": null,
            "color": null,
            "venderId": 1,
            "rfId": "230698"
        }, {
            "skuId": -9999,
            "packageName": "H12",
            "packageUnit": "H12",
            "radio": 12,
            "begrew": 6,
            "depth": 8,
            "width": 4.7,
            "height": 20.3,
            "cubage": 10.846,
            "color": null,
            "venderId": 1,
            "rfId": "230698"
        }],
        "warningEnumSet": [],
        "hangnailDetail": null,
        "moduleType": null,
        "posInfo": null,
        "subSkuListJson": null,
        "subSkuList": [{
            "skuId": -9999,
            "surfaceWidth": 1,
            "surfaceHeight": 1,
            "surfaceDepth": 1,
            "mainWareFlag": 1,
            "title": "舒肤佳柠檬清香健康+清爽系列沐浴露400毫升",
            "rfId": "230698",
            "itemNum": "6903148047811",
            "width": 8,
            "height": 20,
            "depth": 4.3,
            "shelfWareStatus": null
        }],
        "remark": null,
        "layerIdList": null,
        "splitFlag": null,
        "specialAttrJson": {}
    },
    "posDefaultValue": {
        "pageSize": 10,
        "dataMap": {},
        "id": null,
        "status": null,
        "created": null,
        "modified": null,
        "yn": null,
        "creator": null,
        "updator": null,
        "layerId": null,
        "specialAttr": null,
        "serialNumber": null,
        "unitType": null,
        "surfaceWidth": null,
        "surfaceHeight": null,
        "surfaceDepth": null,
        "maxNum": null,
        "minNum": null,
        "actualNum": null,
        "skuId": null,
        "displayPosType": null,
        "posCapacity": null,
        "posWidth": null,
        "posHeight": null,
        "posDepth": null,
        "posX": null,
        "posY": null,
        "posZ": null,
        "axisX": null,
        "axisY": null,
        "axisZ": null,
        "posDirection": null,
        "boxSpec": null,
        "hangnailId": null,
        "imgRotateType": null,
        "xplaceType": null,
        "xsurfaceType": null,
        "xsurfaceWidthType": null,
        "xminSurfaceType": null,
        "xminSurfaceNum": null,
        "xmaxSurfaceType": null,
        "xmaxSurfaceNum": null,
        "xtargetSurfaceType": null,
        "xtargetSurfaceNum": null,
        "xtargetPileType": null,
        "xtargetPileNum": null,
        "xpileType": null,
        "xpilePos": null,
        "xsurfaceNum": null,
        "xpileDirection": null,
        "xtargetSpace": null,
        "yplaceType": null,
        "ysurfaceType": null,
        "ysurfaceWidthType": null,
        "yminSurfaceType": null,
        "yminSurfaceNum": null,
        "ymaxSurfaceType": null,
        "ymaxSurfaceNum": null,
        "ytargetSurfaceType": null,
        "ytargetSurfaceNum": null,
        "ytargetPileType": null,
        "ytargetPileNum": null,
        "ypileType": null,
        "ypilePos": null,
        "ysurfaceNum": null,
        "ypileDirection": null,
        "ytargetSpace": null,
        "zplaceType": null,
        "zsurfaceType": null,
        "zsurfaceWidthType": null,
        "zminSurfaceType": null,
        "zminSurfaceNum": null,
        "zmaxSurfaceType": null,
        "zmaxSurfaceNum": null,
        "ztargetSurfaceType": null,
        "ztargetSurfaceNum": null,
        "ztargetPileType": null,
        "ztargetPileNum": null,
        "zpileType": null,
        "zpilePos": null,
        "zsurfaceNum": null,
        "zpileDirection": null,
        "ztargetSpace": null,
        "warning": null,
        "frontData": null,
        "shelfWareStatus": null,
        "usePartition": null,
        "virtualLayerNumber": null,
        "virtualSerialNumber": null,
        "audFlag": null,
        "audMsg": null,
        "xPileSurfaceWidth": null,
        "xPileSurfaceHeight": null,
        "xPileSurfaceDepth": null,
        "yPileSurfaceWidth": null,
        "yPileSurfaceHeight": null,
        "yPileSurfaceDepth": null,
        "zPileSurfaceWidth": null,
        "zPileSurfaceHeight": null,
        "zPileSurfaceDepth": null,
        "boxSpecList": null,
        "warningEnumSet": [],
        "hangnailDetail": null,
        "moduleType": null,
        "posInfo": null,
        "subSkuListJson": null,
        "subSkuList": null,
        "remark": null,
        "layerIdList": null,
        "splitFlag": null,
        "specialAttrJson": {}
    },
    "goods": [{
        "id": null,
        "type": "elements",
        "moduleName": "goods",
        "tplName": "default",
        "cubeName": "shelvesbuild-e-g-default",
        "desc": "产品",
        "frontCubeData": null,
        "cubeData": {
            "pageSize": 10,
            "dataMap": {},
            "id": null,
            "status": null,
            "created": null,
            "modified": null,
            "yn": null,
            "creator": null,
            "updator": null,
            "positionId": null,
            "skuId": -9999,
            "backColor": "#ffffff",
            "wareSizeSource": 0,
            "nestingHeight": null,
            "nestingWidth": null,
            "nestingDepth": null,
            "boxHeight": null,
            "boxWidth": null,
            "boxDepth": null,
            "boxTotal": null,
            "extendFront": 0,
            "yfingerSpace": 0,
            "xfingerSpace": 0,
            "xextrusionLower": 100,
            "xextendUpper": 100,
            "yextrusionLower": 100,
            "yextendUpper": 100,
            "zextrusionLower": 100,
            "zextendUpper": 100,
            "xsurfaceType": null,
            "xsurfaceWidthType": null,
            "xminSurfaceType": null,
            "xminSurfaceNum": null,
            "xmaxSurfaceType": null,
            "xmaxSurfaceNum": null,
            "xtargetSurfaceType": null,
            "xtargetSurfaceNum": null,
            "xtargetPileType": null,
            "xtargetPileNum": null,
            "ysurfaceType": null,
            "ysurfaceWidthType": null,
            "yminSurfaceType": null,
            "yminSurfaceNum": null,
            "ymaxSurfaceType": null,
            "ymaxSurfaceNum": null,
            "ytargetSurfaceType": null,
            "ytargetSurfaceNum": null,
            "ytargetPileType": null,
            "ytargetPileNum": null,
            "zsurfaceType": null,
            "zsurfaceWidthType": null,
            "zminSurfaceType": null,
            "zminSurfaceNum": null,
            "zmaxSurfaceType": null,
            "zmaxSurfaceNum": null,
            "ztargetSurfaceType": null,
            "ztargetSurfaceNum": null,
            "ztargetPileType": null,
            "ztargetPileNum": null,
            "displayWareWidth": null,
            "displayWareHeight": null,
            "displayWareDepth": null,
            "sourceDisplayWareWidth": null,
            "sourceDisplayWareHeight": null,
            "sourceDisplayWareDepth": null,
            "displayWareWeight": null,
            "posX": null,
            "posY": null,
            "posZ": null,
            "axisX": null,
            "axisY": null,
            "axisZ": null,
            "frontData": null,
            "wareTag": null,
            "maxSurfaceDepth": null,
            "showWareWidth": 8,
            "showWareHeight": 20,
            "showWareDepth": 4.3,
            "showXPileWareWidth": null,
            "showXPileWareHeight": null,
            "showXPileWareDepth": null,
            "showYPileWareWidth": null,
            "showYPileWareHeight": null,
            "showYPileWareDepth": null,
            "showZPileWareWidth": null,
            "showZPileWareHeight": null,
            "showZPileWareDepth": null
        },
        "wareInfoVO": {
            "pageSize": 10,
            "dataMap": {},
            "id": null,
            "status": null,
            "created": null,
            "modified": null,
            "yn": null,
            "creator": null,
            "updator": null,
            "venderId": 1,
            "skuId": -9999,
            "title": "",
            "rfId": "230698",
            "itemNum": "6903148047811",
            "wareId": 128320,
            "shelfWareStatus": "1",
            "bizPrice": 21.9,
            "mainItemNum": null,
            "basicUnit": "EA",
            "chine": "盒",
            "storageType": "常温",
            "wareImgUri": "20190930/07c2693f-2c63-4d32-b77b-b41ac493361a",
            "weight": 20,
            "specInfo": "400.0000ML",
            "brandId": 159,
            "brandName": "舒肤佳",
            "categoryId": "2299",
            "categoryName": "沐浴用品",
            "wareCatId": "14822",
            "wareCat": null,
            "uGrade": null,
            "matkl": "389-003",
            "wareSmallClassify": {
                "id": 5075,
                "code": "389-003",
                "name": "抑菌沐浴",
                "level": 2,
                "currLevelCode": "emc",
                "currLevelName": "商品小分类",
                "totalLevel": 2,
                "venderId": 1,
                "status": 1,
                "parent": {
                    "id": 5044,
                    "code": "389",
                    "name": "沐浴/浴盐",
                    "level": 1,
                    "currLevelCode": "mc",
                    "currLevelName": "商品中分类",
                    "totalLevel": 2,
                    "venderId": 1,
                    "status": 1,
                    "parent": null,
                    "children": null
                },
                "children": null
            },
            "warePackageList": [{
                "skuId": -9999,
                "packageName": "EA",
                "packageUnit": "EA",
                "radio": 1,
                "begrew": null,
                "depth": 4.3,
                "width": 8,
                "height": 20,
                "cubage": 0.393,
                "color": null,
                "venderId": 1,
                "rfId": "230698"
            }, {
                "skuId": -9999,
                "packageName": "H02",
                "packageUnit": "H02",
                "radio": 2,
                "begrew": null,
                "depth": 10,
                "width": 10,
                "height": 10,
                "cubage": 1000,
                "color": null,
                "venderId": 1,
                "rfId": "230698"
            }, {
                "skuId": -9999,
                "packageName": "H06",
                "packageUnit": "H06",
                "radio": 6,
                "begrew": null,
                "depth": null,
                "width": null,
                "height": null,
                "cubage": null,
                "color": null,
                "venderId": 1,
                "rfId": "230698"
            }, {
                "skuId": -9999,
                "packageName": "H12",
                "packageUnit": "H12",
                "radio": 12,
                "begrew": 6,
                "depth": 8,
                "width": 4.7,
                "height": 20.3,
                "cubage": 10.846,
                "color": null,
                "venderId": 1,
                "rfId": "230698"
            }],
            "specType": 0,
            "canReturn": null,
            "imgUri": "20200108/3bf275e5-9e16-45e5-8833-478321281bbe_120x120L",
            "realImgUri": "20200108/3bf275e5-9e16-45e5-8833-478321281bbe",
            "width": 20,
            "depth": 4.3,
            "height": 20,
            "begrew": null,
            "cubage": 0.393,
            "wareOperType": null,
            "wareImgLib": [{
                "pageSize": 10,
                "dataMap": {},
                "id": 2939,
                "status": null,
                "created": "2019-09-20 20:32:07",
                "modified": "2020-01-09 01:46:19",
                "yn": 1,
                "creator": null,
                "updator": null,
                "venderId": 1,
                "skuId": -9999,
                "itemNum": "6903148047811",
                "rfId": "230698",
                "imgUri": "20200108/3bf275e5-9e16-45e5-8833-478321281bbe",
                "realImgUri": null,
                "posType": 1,
                "createUserId": -1,
                "modifyUserId": 1,
                "title": null,
                "queryCode": null,
                "dayBetween": null,
                "chosenDayBetween": null,
                "uploadDateStr": null,
                "posTypeName": null,
                "skuIdList": null,
                "itemNumList": null,
                "wareImgOnlyKey": "1-128320"
            }],
            "wareImgMap": {
                "1": "20200108/3bf275e5-9e16-45e5-8833-478321281bbe_800x800L"
            },
            "wareRealImgMap": {
                "1": "20200108/3bf275e5-9e16-45e5-8833-478321281bbe"
            },
            "wareHighLightMap": null
        }
    }]
};

export default {
    get(params: TextareaCreateParams): FreeObjMap {
        let tplCopy: FreeObjMap = Utils.deepCopy(tpl);

        tplCopy.goods[0].wareInfoVO.width = params.width;
        tplCopy.goods[0].wareInfoVO.height = params.height;
        tplCopy.goods[0].wareInfoVO.title = params.content;
        tplCopy.goods[0].wareInfoVO.weight = params.fontSize;
        
        return tplCopy;
    }
};
